import { IInference, IAstNode } from './typings';
import { TypeGenerator } from '../utils/type';
import { isStringLike, isDigit, isNull, isEnum, isBoolean } from '../utils/type';
import { InferenceError } from '../errors';


const EqualDataTypes = [
  'String', 'Email', 'Url', 'PhoneNr',
  'DateTime', 'Date', 'Time',
  'Number', 'Integer',
  'Boolean',
  'Id'
];

export function inferenceEqualComparison(inference: IInference, astNode: IAstNode) {
  const operator = astNode.operator!;
  const isManyToOne = operator.startsWith('ALL-') || operator.startsWith('ANY-');
  const leftType = inference(astNode.left)!;
  const rightType = inference(astNode.right)!;
  const token = astNode.token;

  if (isNull(leftType) || isNull(rightType)) {
    throw new InferenceError('comparison-value-error', '无效的比较值 \'Null\'', token.position);
  }

  if (isManyToOne) {
    if (!leftType.isArray) {
      throw new InferenceError('comparison-value-error', `比较符左侧必须为数组类型`, token.position);
    }

    if (rightType.isArray) {
      throw new InferenceError('comparison-value-error', `比较符右侧不能为数组类型`, token.position);
    }
  } else if (!!leftType.isArray !== !!rightType.isArray) {
    throw new InferenceError('comparison-value-error', `比较符两侧类型不匹配`, token.position);
  }


  if ((isStringLike(leftType) || isEnum(leftType)) &&
    (isStringLike(rightType, false) || isEnum(rightType, false))) {
    return TypeGenerator.Boolean();
  }

  if (isDigit(leftType) && isDigit(rightType, false)) {
    return TypeGenerator.Boolean();
  }

  if (isBoolean(leftType) && isBoolean(rightType, false)) {
    return TypeGenerator.Boolean();
  }

  if (!EqualDataTypes.includes(leftType.type)) {
    throw new InferenceError('comparison-value-error', '相等比较符左侧值类型错误', token.position);
  }

  if (!EqualDataTypes.includes(rightType.type) || rightType.isArray) {
    throw new InferenceError('comparison-value-error', '相等比较符右侧值类型错误', token.position);
  }

  if (leftType.type === rightType.type && !rightType.isArray) {
    return TypeGenerator.Boolean();
  } else {
    throw new InferenceError('comparison-value-error', '比较符两端类型不匹配', token.position);
  }
}
